import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentAthlete } from '../contexts/AthleteContext';
import { X, User } from 'lucide-react';

/**
 * Sticky top-right pill showing the "current athlete" in context.
 * Visible only for staff/admin (player/parent always have a single linked athlete).
 */
const CurrentAthletePill = ({ userRole }) => {
  const { currentAthlete, clearCurrentAthlete } = useCurrentAthlete();
  const navigate = useNavigate();

  const isStaff = userRole === 'Admin' || userRole === 'Staff';
  if (!isStaff || !currentAthlete) return null;

  return (
    <div
      className="fixed top-2 right-3 md:top-3 md:right-4 z-40 flex items-center gap-2 rounded-full border border-emerald-200 bg-white dark:bg-gray-800 dark:border-emerald-900/40 shadow-sm pl-3 pr-1 py-1 text-xs"
      data-testid="current-athlete-pill"
    >
      <User size={12} className="text-emerald-600" />
      <button
        type="button"
        onClick={() => navigate(`/athlete/${currentAthlete.id}/360`)}
        className="font-medium text-gray-800 dark:text-gray-200 hover:text-emerald-700 max-w-[180px] truncate"
        data-testid="current-athlete-name"
        title={`${currentAthlete.full_name}${currentAthlete.squad ? ' · ' + currentAthlete.squad : ''}`}
      >
        {currentAthlete.full_name}
      </button>
      {currentAthlete.squad ? (
        <span className="text-[10px] text-gray-400">· {currentAthlete.squad}</span>
      ) : null}
      <button
        type="button"
        onClick={clearCurrentAthlete}
        className="ml-1 w-5 h-5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center justify-center text-gray-400 hover:text-gray-600"
        data-testid="current-athlete-clear"
        aria-label="Clear current athlete"
      >
        <X size={11} />
      </button>
    </div>
  );
};

export default CurrentAthletePill;
